import axios from 'axios';
import config from '../config';

const apiUrl = config.publicBaseUrl;

export const api = {
    fetchVideos: async () => {
        try {
            const response = await axios.get(`${apiUrl}/videos`, {
                headers: {
                    'Accept': 'application/json',
                },
                withCredentials: false
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching videos:', error);
            throw error;
        }
    },
    fetchStandings: async (league) => {
        try {
            const response = await axios.get(`${apiUrl}/standings`, {
                headers: {
                    'Accept': 'application/json',
                },
                params: {
                    league:league
                },
                withCredentials: false
            });
            return response.data
        } catch (error) {
            console.error('Error fetching standings:', error);
            throw error;
        }
    },
    fetchMatches: async (league) => {
        try {
            const response = await axios.get(`${apiUrl}/playingschedules`, {
                headers: {
                    'Accept': 'application/json',
                },
                params: {
                    league:league
                },
                withCredentials: false
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching matches:', error);
            throw error;
        }
    },
    fetchSingleMatch: async (matchId) => {
        try {
            const response = await axios.get(`${apiUrl}/match`, {
                headers: {
                    'Accept': 'application/json',
                },
                params: {
                    match_id:matchId
                },
                withCredentials: false
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching match:', error);
            throw error;
        }
    },
};
